
export const navbar = {
  'backoffice.navbar.notifications': 'Benachrichtigungen',
  'backoffice.navbar.language': 'Sprache',
  'backoffice.navbar.signIn': 'Anmelden'
};
